import { jsx as _jsx } from "react/jsx-runtime";
export const LoadingSpinner = ({ size = 'md', className = '', }) => {
    const sizeClasses = {
        sm: 'h-4 w-4',
        md: 'h-8 w-8',
        lg: 'h-12 w-12',
    };
    return (_jsx("div", { className: `flex justify-center items-center ${className}`, children: _jsx("div", { className: `${sizeClasses[size]} border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin` }) }));
};
